import React from 'react';
import * as keyMenu from '../scripts/KeyMenu';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faCog, faCalendarAlt, faFileInvoiceDollar, faFileInvoice, faStopwatch, faUserClock, faAddressCard, faCalendarCheck, faSquarePollVertical } from "@fortawesome/free-solid-svg-icons";
import * as storage from '../utils/storage';
import styles from '../styles/menu.module.css';
import stylesHome from '../styles/home.module.css';

export function getMenuConfig(key) {
    switch (key) {
        case keyMenu.MENU_PUNCH:
            return {
                icon: <FontAwesomeIcon icon={faStopwatch} className="fa-w-16" />,
                iconHome: <FontAwesomeIcon icon={faStopwatch} className={stylesHome.iconHome} />,
                url: './punch'
            };
        case keyMenu.MENU_TIMESHEET:
            return {
                icon: <FontAwesomeIcon icon={faClock} className="fa-w-16" />,
                iconHome: <FontAwesomeIcon icon={faClock} className={stylesHome.iconHome} />,
                url: './timesheet'
            };
        case keyMenu.MENU_SCHEDULE:
            return {
                icon: <FontAwesomeIcon icon={faCalendarAlt} className="fa-w-16" />,
                iconHome: <FontAwesomeIcon icon={faCalendarAlt} className={stylesHome.iconHome} />,
                url: './schedule'
            };
        case keyMenu.MENU_DOCUMENTS:
            return {
                icon: <FontAwesomeIcon icon={faFileInvoice} className="fa-w-16" />,
                iconHome: <FontAwesomeIcon icon={faFileInvoice} className={stylesHome.iconHome} />,
                url: './documents'
            };
        case keyMenu.MENU_EXPENSES:
            return {
                icon: <FontAwesomeIcon icon={faFileInvoiceDollar} className="fa-w-16" />,
                iconHome: <FontAwesomeIcon icon={faFileInvoiceDollar} className={stylesHome.iconHome} />,
                url: './expenseAccount'
            };
        case keyMenu.MENU_REQUEST:
            return {
                icon: <FontAwesomeIcon icon={faUserClock} className={styles.iconRequest} />,
                iconHome: <FontAwesomeIcon icon={faUserClock} className={stylesHome.iconRequest} />,
                url: './request'
            };
        case keyMenu.MENU_SETTINGS:
            return {
                icon: <FontAwesomeIcon icon={faCog} className="fa-w-16" />,
                iconHome: <FontAwesomeIcon icon={faCog} className={stylesHome.iconHome} />,
                url: './settings'
            };
        case keyMenu.MENU_PROFILE:
            return {
                icon: <FontAwesomeIcon icon={faAddressCard} className="fa-w-16" />,
                iconHome: <FontAwesomeIcon icon={faAddressCard} className={stylesHome.iconHome} />,
                url: './myFile'
            };
        case keyMenu.MENU_SCHEDULEAVAILABILITY:
            return {
                icon: <FontAwesomeIcon icon={faCalendarCheck} className="fa-w-16" />,
                iconHome: <FontAwesomeIcon icon={faCalendarCheck} className={stylesHome.iconHome} />,
                url: './scheduleAvailability'
            };
        case keyMenu.MENU_SURVEY:
            return {
                icon: <FontAwesomeIcon icon={faSquarePollVertical} className="fa-w-16" />,
                iconHome: <FontAwesomeIcon icon={faSquarePollVertical} className={stylesHome.iconHome} />,
                url: './survey'
            };
        case keyMenu.MENU_BANKBALANCE:
            return {
                icon: <FontAwesomeIcon icon={faSquarePollVertical} className="fa-w-16" />,
                iconHome: <FontAwesomeIcon icon={faSquarePollVertical} className={stylesHome.iconHome} />,
                url: './bankBalance'
            };
    }
}


export function getAccessMenu(key){
    const config = JSON.parse(storage.getMenu());

    const menu = config.find(item => item.codeMenu === key);

    return menu !== undefined;
}

export function getAccessTab(key) {
    const config = JSON.parse(storage.getMenu()).filter(x => x.isTab);

    const menu = config.find(item => item.codeMenu === key);

    return menu !== undefined;
}